import { Component, ChangeDetectionStrategy, input, computed, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChartModule } from 'primeng/chart';
import { WalletRecap } from '../../models/wallet-recap.model';
import { WalletStoreService } from '../../services/etiquette-service/wallet-store.service';
import { MonthlyRecap } from '../../models/monthly-recap.model';

@Component({
  selector: 'spike-wallet-bar-chart',
  templateUrl: './wallet-bar-chart.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, ChartModule]
})
export class WalletBarChartComponent {
  public readonly walletStoreService = inject(WalletStoreService);
  public readonly walletProgressListLiq = input.required<MonthlyRecap[]>();
  public readonly walletProgressListInv = input.required<MonthlyRecap[]>();

   public readonly chartData = computed(() => {
      const labels = ['Gen', 'Feb', 'Mar', 'Apr', 'Mag', 'Giu', 'Lug', 'Ago', 'Set', 'Ott', 'Nov', 'Dic'];
      const months = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dic'];
      
      const getMonthlySum = (list: MonthlyRecap[]) => months.map(m => list.reduce((acc, curr) => acc + (curr[m as keyof MonthlyRecap] || 0), 0));
  
      return {
        labels,
        datasets: [
          { label: 'Liquidità', backgroundColor: '#1ab394', data: getMonthlySum(this.walletProgressListLiq()) },
          { label: 'Investimento', backgroundColor: '#36A2EB', data: getMonthlySum(this.walletProgressListInv()) }
        ]
      };
    });

    public readonly chartOptions = {
    responsive: false,
    plugins: {
      legend: {
        position: 'bottom',    // Spostandola sotto, il cerchio ha più spazio ai lati per centrarsi
        labels: {
          pointStyle: 'circle',
          usePointStyle: true,
          padding: 20          // Distanza tra legenda e grafico
        }
      }
    },
    layout: {
      padding: 10              // Evita che i bordi del grafico tocchino i margini del div
    },
     scales: { x: { stacked: true }, y: { stacked: true,  beginAtZero: true } } 
  }


}